// extracted by mini-css-extract-plugin
var _1 = "TestMultipleChoiceElement_active__babfa";
var _2 = "TestMultipleChoiceElement_dnd__6c2df";
var _3 = "TestMultipleChoiceElement_items__1c13b";
var _4 = "TestMultipleChoiceElement_show__03e79";
var _5 = "TestMultipleChoiceElement_wrapItem__a0520";
export { _1 as "active", _2 as "dnd", _3 as "items", _4 as "show", _5 as "wrapItem" }
